import { token } from '@cp/shared/di';
import type { IConfigManager } from '@cp/shared/config';

export const CONFIG_MANAGER = token<IConfigManager>('ConfigManager');
